import ReactGA from 'react-ga4';

// Replace with your actual Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-1SYDY6T8J6';

/**
 * Initialise Google Analytics 4.
 * Call once at app startup (index.js or App.js).
 */
export const initGA = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-PLACEHOLDER') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  } else {
    // Still initialise in development so events are logged to console
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      testMode: process.env.NODE_ENV !== 'production',
    });
  }
};

/**
 * Track a page view.
 * @param {string} path - The URL path (e.g. "/work/baby-blocker")
 * @param {string} [title] - Optional page title
 */
export const trackPageView = (path, title) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    ...(title ? { title } : {}),
  });
};

/**
 * Track a custom event.
 * @param {string} category - Event category (e.g. "3D Scene")
 * @param {string} action   - Event action (e.g. "interact")
 * @param {string} [label]  - Optional label (e.g. scene name)
 * @param {number} [value]  - Optional numeric value
 */
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    ...(label ? { label } : {}),
    ...(value !== undefined ? { value } : {}),
  });
};

/**
 * Track interaction with a Three.js scene.
 * Convenience wrapper around trackEvent.
 * @param {string} sceneName - e.g. "ARHeadScene", "PhoneScene", "DefaultScene", "MonoScene"
 * @param {string} action    - e.g. "drag_start", "drag_end", "orbit"
 */
export const trackSceneInteraction = (sceneName, action) => {
  trackEvent('3D Scene', action, sceneName);
};
